import { operatorApiFetch } from './apiService';

export const inventoryMovementService = {
  getRecords: async (params) => {
    const response = await operatorApiFetch('inventory_movements/get_records', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },
  getIds: async (params) => { // TableIndex needs getAll too
    const response = await operatorApiFetch('inventory_movements/get_ids', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },
  export: async (ids) => {
    const res = await operatorApiFetch('inventory_movements/export', {
      method: 'POST',
      body: { ids }
    });
    return res.json();
  }
};

export default inventoryMovementService;
